
<ion-content #scrollContent>
  <div class="bg-notebook-paper">
      <div class="message-avatar">
        <div class="icon-circle" [ngClass]="{ 'needs-info': currentMessage?.needs_info }">
          <div class="inner-circle">
            <ion-icon *ngIf="currentMessage?.needs_info" name="alert" size="large"></ion-icon>
            <ion-icon *ngIf="!currentMessage?.needs_info" name="paper-plane" size="large"></ion-icon>
          </div>
        </div>
      </div>
    <form [formGroup]="addressForm" (ngSubmit)="onSaveAndContinue()">
      <h3 class="form-title">
          <span *ngIf="currentMessage.needs_info">Your message requires additional information.</span>
          <span *ngIf="!currentMessage.needs_info"> Edit delivery details</span>
      </h3>
        <p class="form-subtitle">
        Please double-check the details below and fill in any missing details:
      </p>
      <div id="main-content" #mainContent>
        <ion-list  class="address-fields" [class.submitted]="formSubmitted" no-lines>
            <p class="section-title">
            <span>
              Your message will be sent to:
            </span>
            </p>
  
            <div class="field-section" formGroupName="toAddress">
              <ion-item class="form-field name" [class.valid]="addressForm.controls.toAddress.controls.first_name.valid">
                <ion-label position="stacked">Inmate First Name:</ion-label>
                  <ion-input
                    autoComplete="nope"
                    type="text"
                    formControlName="first_name"
                  ></ion-input>
              </ion-item>
              <ion-item class="form-field name" [class.valid]="addressForm.controls.toAddress.controls.last_name.valid">
                <ion-label  position="stacked">Inmate Last Name:</ion-label>
                  <ion-input
                    autoComplete="nope"
                    type="text"
                    formControlName="last_name"
                  ></ion-input>
              </ion-item>
              <ion-item class="form-field name" [class.valid]="addressForm.controls.toAddress.controls.facility.valid">
                <ion-label position="stacked">Facility/Location:</ion-label>

                <ion-input
                  autoComplete="nope"
                  type="text"
                  formControlName="facility"
                ></ion-input>
              </ion-item>

              <p class="id-number-note"> Confirm ID Number</p>

              <ion-item class="form-field name" [class.valid]="addressForm.controls.toAddress.controls.id_number.valid">
                <ion-label position="stacked" >ID Number:</ion-label>
                <ion-input
                  autoComplete="nope"
                  type="text"
                  formControlName="id_number"
                ></ion-input>
              </ion-item>
          </div>
          <p class="section-title">Your return address:</p>
          <p class="note-text">A return address may be required to deliver your message.</p>
          <div class="field-section return-address">
            <app-stripe-address 
              #stripeAddress
              [debounceTime]="300"
              [defaultAddress]="currentMessage.returnAddress.address_line1 ? currentMessage.returnAddress : currentMessage.defaultReturnAddress || {}"
              (addressChange)="onAddressChanged($event)">
            </app-stripe-address>
          </div>
        </ion-list>
      </div>
    </form>
  </div>
</ion-content>

<ion-footer id="modal-footer">
  <div id="message-actions">
    <ion-grid>
      <ion-row>
        <ion-col col-6 class="back">
          <ion-button ion-button (click)="onCancel()" icon-left>
            <div class="button-inner">
              <ion-icon name="arrow-back"></ion-icon>
              Back
            </div>
          </ion-button>
        </ion-col>
        <ion-col col-6 class="continue">
          <ion-button ion-button icon-right (click)="onSaveAndContinue()" [disabled]="!addressForm.controls.toAddress.valid || !mailingAddressValid">
            <div class="button-inner">
              Submit
              <ion-icon name="arrow-forward"></ion-icon>
            </div>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-footer>
